import { z } from "zod";

export const organisationTypes = ["hospital", "municipal", "provider"] as const;

export const organisationSchema = z.object({
  id: z.coerce.string(),
  type: z.enum(organisationTypes),
  coordinates: z.tuple([z.number(), z.number()]),
  name: z.string(),
  aggregatorId: z.coerce.string().nullable().optional(),
  aggregatorName: z.string().nullable().optional(),
  authorName: z.string().nullable().optional(),
});

export type Organisation = z.infer<typeof organisationSchema>;
